import {MeldingTilBruker, Varighet} from "felles/tjenester/MeldingTilBruker";
import {Debugger} from "debug";
import {IHttpResponse, ILogService, resource} from "angular";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {HttpStatus} from "../infrastruktur/BasisRessurs";
import {feilkodeSomKunLoggesTilKonsoll} from "felles/infrastruktur/Logging";

const debug: Debugger = require('debug')('RessursFeilhåndtering');

type ResponseVedFeil = resource.IResourceResponse | IHttpResponse<void>;

/** Håndtering av feil ved http-requester. */
export class RessursFeilhåndtering {
    static regNavn = 'RessursFeilhåndtering';

    static forInjisering() {
        return [
            regNavn.ng.$log,
            MeldingTilBruker.regNavn,
            RessursFeilhåndtering
        ]
    }

    /** Returnerer sann dersom angitt respons har status på 400-tallet. */
    static erStatus4XX(respons: resource.IResourceResponse){
        if (respons.status < 400) return false;
        if (respons.status >= 500) return false;
        return true;
    }

    /** feilkoder som indikerer at kallende bruker ikke har tilgang til forespurt informasjon */
    static manglendeTilgangFeilkoder = [HttpStatus.møteIkkePublisert, HttpStatus.protokollIkkePublisert, HttpStatus.ikkeFunnet, HttpStatus.skjermet, HttpStatus.gone, HttpStatus.privat]

    /** sann dersom angitt feil indikerer at kallende bruker ikke har tilgang til forespurt informasjon */
    static erManglendeTilgangFeil(respons: resource.IResourceResponse): boolean {
        return RessursFeilhåndtering.manglendeTilgangFeilkoder.includes(respons.status);
    }

    /** returnerer en funksjon som svarer sann dersom angitt feil indikerer at kallende bruker ikke har tilgang til forespurt informasjon */
    static ignorerDersomManglendeTilgangFeil(respons: resource.IResourceResponse): boolean {
        //returnerer sann -> vi håndterer feilen selv
        return RessursFeilhåndtering.erManglendeTilgangFeil(respons);
    }

    constructor(private $log: ILogService, private meldingTilBruker: MeldingTilBruker) {
    }

    /** Returnerer funksjon som kaller {@link #visFeilmelding()} når kalt.
     * Dersom eksternHåndtering er angitt og denne returnerer true vil videre feilhåndtering avbrytes.
     * Logger melding til server via $log tjenesten med mindre responsstatus er 401 (ikke-autentisert) eller 500 (Serverfeil).
     * Dette kan overstyres ved å angi logTilKunConsole-argumentet. */
    public håndterRequestFeil(melding: () => string,
                              logTilKunConsole: (respons: resource.IResourceResponse) => boolean = null,
                              eksternHåndtering: (feil:resource.IResourceResponse)=>boolean = ()=>false): (feil: resource.IResourceResponse) => void {
        if (logTilKunConsole == null) logTilKunConsole = this.standardLogTilKunConsole();
        return (feil: resource.IResourceResponse) => {
            if (eksternHåndtering(feil)) return;
            return this.visFeilmelding(feil, melding(), logTilKunConsole(feil));
        }
    }

    /** Viser melding produsert av angitt melding-argument til bruker via {@link MeldingTilBruker} tjenesten samt
     * logger melding til server via $log tjenesten dersom logTilKunConsole er false */
    public visFeilmelding(feil: ResponseVedFeil, melding: string, logTilKunConsole: boolean): void {
        debug('visFeilmelding logTilKunConsole:', logTilKunConsole, feil)
        this.logFeil(feil, melding, logTilKunConsole);
        this.meldingTilBruker.feilmelding(melding, Varighet.timeout, null, false);
    }

    private logFeil(feil: ResponseVedFeil, melding: string, logTilKunConsole: boolean): void {
        try {
            if (logTilKunConsole) {
                console.error(melding, feil);
                return;
            }

            //feil av typen -e (error/abort) - som regel pga manglende nettverk - logger vi ikke til server
            //disse feilene kommer som følge av callbackene xhr.onError eller xhr.onAbort og indikerer at ingen respons
            //har blitt mottatt (i tilfellet "intet nettverk" har ingen request blitt opprettet)
            //se https://github.com/systemfabrikken/lederplan/issues/1648 og node_modules/angular/angular.js for detaljer
            if (feil.status == -1) return;

            //log feil til server
            this.$log.error(`${melding}, feil:${feil.status} (${feil.statusText}/${feil['xhrStatus']}), url:${feil.config?.url}`);

        } catch (e) {
            this.$log.error(`${melding}, feil ved prosessering av feilmelding, ${e}`);
        }
    }

    private standardLogTilKunConsole(): (feil: resource.IResourceResponse) => boolean {
        return (feil: resource.IResourceResponse) => feilkodeSomKunLoggesTilKonsoll(feil)
    }
}
